import { NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "./sse.service";
import * as i2 from "@angular/common/http";
var EmsdashboardService = /** @class */ (function () {
    function EmsdashboardService(_zone, _sseService, http) {
        this._zone = _zone;
        this._sseService = _sseService;
        this.http = http;
    }
    EmsdashboardService.prototype.getServerSentEvent = function (url) {
        var _this = this;
        return Observable.create(function (observer) {
            var es = _this._sseService.getEventSource(url);
            es.onmessage = function (event) {
                _this._zone.run(function () { return observer.next(event); });
            };
            es.onerror = function (error) {
                observer.error(error);
            };
        });
    };
    EmsdashboardService.prototype.getParameterConfig = function (meterid) {
        return this.http.get("getEmsParameterConfig?meterid=" + meterid);
    };
    EmsdashboardService.prototype.getKWH = function (data) {
        return this.http.post("getKWHDATA", data);
    };
    EmsdashboardService.prototype.getMeterCount = function (deviceid) {
        return this.http.get("getMeterCount?deviceid=" + deviceid);
    };
    EmsdashboardService.prototype.getEnergyMeterData = function (data) {
        return this.http.post("getEnergyMeterData", data);
    };
    EmsdashboardService.prototype.getCurrentMonthKwh = function (userid) {
        return this.http.post("getCurrentMonthKwh", userid);
    };
    EmsdashboardService.prototype.meterStatus = function (meters) {
        return this.http.post("meterStatus", meters);
    };
    EmsdashboardService.prototype.getemsmonthdata = function (meters) {
        return this.http.post("getemsmonthdata", meters);
    };
    EmsdashboardService.prototype.alertSections = function (meters) {
        return this.http.post("alertSections", meters);
    };
    EmsdashboardService.prototype.getMonthwiseAveragePF = function (userid) {
        return this.http.post("getMonthwiseAveragePF", userid);
    };
    EmsdashboardService.prototype.getMonthwiseConsumptionData = function (userid) {
        return this.http.post("getMonthwiseConsumptionData", userid);
    };
    EmsdashboardService.prototype.getDailyConsumptionData = function (userid) {
        return this.http.post("getDailyConsumptionData", userid);
    };
    EmsdashboardService.prototype.getAlertData = function (body) {
        return this.http.post("getAlertData", body);
    };
    EmsdashboardService.prototype.gethoverdatatree = function (body) {
        return this.http.post("gethoverdatatree", body);
    };
    EmsdashboardService.prototype.getAlertDataReport = function (body) {
        return this.http.post("getAlertDataReport", body);
    };
    EmsdashboardService.prototype.getCurrentAndPreviousMonthsKwhData = function (body) {
        return this.http.post("getCurrentAndPreviousMonthsKwhData", body);
    };
    EmsdashboardService.prototype.getCurrentAndPreviousDaysKwhData = function (body) {
        return this.http.post("getCurrentAndPreviousDaysKwhData", body);
    };
    EmsdashboardService.prototype.getTotalMonthlyData = function (body) {
        return this.http.post("getTotalMonthlyData", body);
    };
    EmsdashboardService.prototype.getLastUpdatedAlert = function (body) {
        return this.http.post("getLastUpdatedAlert", body);
    };
    EmsdashboardService.prototype.getEMSLiveAlerts = function (body) {
        return this.http.post("getEMSLiveAlerts", body);
    };
    EmsdashboardService.prototype.getLastUpdatedEMSAlertsData = function (body) {
        return this.http.post("getLastUpdatedEMSAlertsData", body);
    };
    EmsdashboardService.prototype.getLiveEMSAlertsData = function (body) {
        return this.http.post("getLiveEMSAlertsData", body);
    };
    EmsdashboardService.prototype.getIndividualMeterMonthData = function (body) {
        return this.http.post("getIndividualMeterMonthData", body);
    };
    EmsdashboardService.prototype.getIndividualEnergyMeterAlerts = function (body) {
        return this.http.post("getIndividualEnergyMeterAlerts", body);
    };
    EmsdashboardService.prototype.getEnergyMeterIds = function (body) {
        return this.http.post("getEnergyMeterIds", body);
    };
    EmsdashboardService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EmsdashboardService_Factory() { return new EmsdashboardService(i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(i1.SseService), i0.ɵɵinject(i2.HttpClient)); }, token: EmsdashboardService, providedIn: "root" });
    return EmsdashboardService;
}());
export { EmsdashboardService };
